import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import MarkerClusterer from './markerclusterer';
import img from '../../img/m1.png';

const evtNames = [
  'click',
  'dblclick',
  'dragend',
  'mousedown',
  'mouseout',
  'mouseover',
  'mouseup',
  'recenter',
];

function MarkerCluster(props) {
  const {
    map,
    google,
    markers,
    event,
    getPrice,
    onClickInfo,
    // currency,
    currencyLog,
    locale,
  } = props;
  // This hook works like ComponentWillMount
  // The  hook isn't really needed, this whole thing worked without it,
  // I added the hook so that I could implement a cleanup function
  // eslint-disable-next-line consistent-return
  const [check, setCheck] = useState('');
  const [checkEvent, setCheckEvent] = useState(event);
  if (JSON.stringify(checkEvent) !== JSON.stringify(event)) {
    setCheckEvent(event);
  }
  MarkerClusterer.prototype.google = google;
  MarkerClusterer.prototype.imgUrl = img;
  MarkerClusterer.prototype.getPosition = (imgs) => imgs;
  useEffect(() => {
    if (map && markers) {
      let clusterer;
      const mapMarkers = markers.map((marker, index) => {
        const entry = new google.maps.InfoWindow({
          position: {
            lat: marker.lat,
            lng: marker.lng,
          },
          map,
          name: marker.name,
          disableAutoPan: true,
        });

        const div = document.createElement('div');
        div.innerHTML = `<div>${
          event ? getPrice(event[index]) : (index + 1).toString()
        }</div>`;
        // }</div><div>${currency()}</div>`;
        div.className = 'offerBox_wrapper_map';
        div.onclick = () => {
          // eslint-disable-next-line no-use-before-define
          const positionCluster = clusterer.getMarkers()[index].getPosition();
          onClickInfo(
            {
              position: {
                lat: positionCluster.lat(),
                lng: positionCluster.lng(),
              },
              index: event[index],
            },
            () => {
              setCheck(entry);
              entry.close();
            },
          );
        };
        entry.setContent(div);
        // eslint-disable-next-line no-shadow
        const handleEvent = ({ event, marker, entry }) => {
          if (props[event]) {
            props[event]({
              props,
              marker,
              event,
              entry,
            });
          }
        };
        evtNames.forEach((e) => {
          entry.addListener(e, () =>
            handleEvent({
              event: e,
              marker,
              entry,
            }),
          );
        });

        return entry;
      });
      clusterer = new MarkerClusterer(
        map,
        mapMarkers,
        { imagePath: '/static/images/maps/m', minimumClusterSize: 15 },
        google,
      );
      // Cleanup function. Note, this is only returned if we create the markers
      return () => {
        clusterer.clearMarkers();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [map, google, check, checkEvent, locale, currencyLog]);
  // markers, event, getPrice, onClickInfo, props, currency
  // Do we need to render anything??
  return null;
}

MarkerCluster.propTypes = {
  map: PropTypes.shape({}),
  google: PropTypes.shape({}),
  markers: PropTypes.arrayOf(
    PropTypes.shape({
      position: PropTypes.shape({
        lat: PropTypes.number.isRequired,
        lng: PropTypes.number.isRequired,
      }).isRequired,
      name: PropTypes.string.isRequired,
    }),
  ),
};

export default MarkerCluster;
